import { useSnackbar } from "notistack";
import { useCallback, useEffect } from "react";
import { useDispatch } from "react-redux";
import errorFormat from "../../../../../utils/errorFormat";
import { resetarEstado } from "../publicacaoSlice";

interface StatusType {
  isSuccess?: boolean;
  isError?: boolean;
  [key: string]: any;
}

export const useNoticiaStatusNotifier = (
  status: StatusType | undefined,
  successMsg: string,
  errorMsg: string,
  setLoading?: (value: boolean) => void
) => {
  const dispatch = useDispatch();
  const enqueueSnackbar = useSnackbar().enqueueSnackbar;

  useEffect(() => {
    if (!status) return;

    if (status.isSuccess) {
      enqueueSnackbar(successMsg, { variant: "success" });
      dispatch(resetarEstado());
    } else if (status.isError) {
      enqueueSnackbar(errorMsg, { variant: "error" });
   const erroReturn: string = errorFormat(status.error);
      enqueueSnackbar(erroReturn, { variant: "error" });
      setLoading?.(false);
    }
  }, [status, successMsg, errorMsg, dispatch, enqueueSnackbar]);
};
